module.exports = __webpack_public_path__ + "media/images/icon-save-13cf542fbbe8d1432285d5d1c7fb8fe4.svg";